<template lang="html">
  <v-app>
    <section class="movie">
      <div id="MovieCont" class="movie_page page-bottom" key="movie_page">
        <h1>ムービー</h1>

        <div class="mbtn_column">
          <MovieButton
            :btnNum="1"
            :movieImg="require('../assets/movie/movie1.png')"
            :movieId="movieData[0]"
            @modal-open="modalOpen($event)"
          />
          <!-- <MovieButton
            :btnNum="2"
            :movieId="movieData[1]"
            :movieImg="require('../assets/movie/movie2.png')"
            @modal-open="modalOpen($event)"
          />
          <MovieButton
            :btnNum="3"
            :movieId="movieData[2]"
            :movieImg="require('../assets/movie/movie3.png')"
            @modal-open="modalOpen($event)"
          /> -->
        </div>
        <!-- ボタンここまで -->
        <MovieModal
          :modal-content="modalContent"
          :is-open="isOpen"
          @modal-close="modalClose()"
        />
      </div>
    </section>
  </v-app>
</template>

<script>
  import MovieButton from "./MovieButton";
  import MovieModal from "./MovieModal";

  export default {
    name: "MovieCont",
    components: {
      MovieButton,
      MovieModal,
    },
    data() {
      return {
        isOpen: false,
        modalContent: {},
        movieData: ["HPu9yaTjL8c", "HPu9yaTjL8c", "HPu9yaTjL8c"], //youtubeID指定
      };
    },
    methods: {
      modalOpen(event) {
        console.log(event);
        this.modalContent = event;
        this.isOpen = true;
      },
      modalClose() {
        this.isOpen = false;
      },
    },
  };
</script>
<!-- scss直書きだとコンパイルが通らないので外部に書くこと -->
<style scoped>
  @import "../css/movie.css";
</style>
